import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
  tooltipMainText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    fontFeatureSettings: '\'pnum\' on, \'lnum\' on'
  },
  tooltip: {
    zIndex: 1000,
    margin: '5px 10px 0 0',
    background: '#4E4C4C',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    borderRadius: 0,
    padding: '10px 15px',
  },
  arrow: {
    color: '#4E4C4C',
  },
});

export default (() => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Tooltip
        title={
          <React.Fragment>
            <div className={classes.tooltipMainText}>
              The field has a default or autogenerated value.
              It will appear after the form or related fields saved
            </div>
          </React.Fragment>

        }
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
        }}
        arrow
        interactive="true"
      >
        <InfoOutlinedIcon
          style={{
            color: '#548FFC',
            fontSize: 20,
            marginLeft: '5px',
          }}
        />
      </Tooltip>
    </React.Fragment>
  );
});
